// EVENTSFLO-EMAIL-SAFETY-PREVIEW-RECIPIENT-REDIRECT-AND-AUDIT-V1
//
// Frontend "are-you-sure?" gate that fires BEFORE the admin triggers
// an access-link send to a non-TEST recipient. Defence in depth: the
// backend safety redirect should already protect outbound delivery in
// preview, but the UI must still slow a human down when the apparent
// recipient is a real person.
//
// Returns true if the send should proceed, false if the admin cancels.

const SAFE_DOMAIN_SUFFIXES = ["example.com", "hillsdon.com"];

export function isObviouslyTestRecipient({ name, email }) {
  const n = (name || "").toString().toLowerCase();
  if (n.includes("test")) return true;
  const e = (email || "").toString().toLowerCase().trim();
  if (!e || !e.includes("@")) return true; // missing email — separate guard
  const domain = e.split("@").pop();
  return SAFE_DOMAIN_SUFFIXES.some((d) => domain === d || domain.endsWith(`.${d}`));
}

export function confirmRealRecipientSend({ name, email }) {
  if (isObviouslyTestRecipient({ name, email })) return true;
  // window.prompt is intentional — it is a typed-CONFIRM gate, not a
  // styled modal. Replacing with a shadcn dialog would mean a much
  // larger UI change. The product brief explicitly allows this.
  const display = email || "(no email)";
  const typed = window.prompt(
    "⚠ EventsFlo email safety\n\n" +
      "You are about to send an access link to a real email address:\n\n" +
      `   ${display}\n\n` +
      "In preview, the backend will redirect this email to " +
      "Eventsflo.test@hillsdon.com.\n\n" +
      "Type CONFIRM to continue, or Cancel to abort.",
    "",
  );
  return typed === "CONFIRM";
}
